var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    rx: 1,
    fill: "#F7F9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    rx: 1,
    fill: "#EEF0F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 29,
    rx: 0.5,
    fill: "white",
    stroke: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4947 8H13.4617V9.30312C15.0906 9.30312 16.7195 9.30638 18.3502 9.29809C18.6319 9.27205 18.9152 9.32626 19.1673 9.45446C19.2981 9.70814 19.3535 9.99394 19.327 10.2781C19.3189 13.1031 19.3179 15.9273 19.324 18.7508C19.3512 19.2263 19.3327 19.7033 19.2686 20.1753C19.2035 20.5138 18.7965 20.5221 18.5247 20.5334C16.8383 20.5381 15.1502 20.5301 13.462 20.5334V21.9985H12.4509C9.96994 21.5489 7.48393 21.1322 5 20.6975V9.30312C7.49874 8.86924 9.99748 8.44129 12.4947 8Z",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4619 9.79065H18.834V20.0462H13.4619V19.0689H14.765V17.9301H13.4619V17.2786H14.765V16.1395H13.4619V15.488H14.765V14.3486H13.4619V13.6971H14.765V12.558H13.4619V11.9082H14.765V10.7674H13.4619V9.79065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.415 10.7673H17.6955V11.9076H15.415V10.7673Z",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8222 12.2926C10.19 12.2665 10.5591 12.2443 10.9293 12.226C10.4949 13.1172 10.0571 14.0066 9.61578 14.8941C10.0636 15.8057 10.5209 16.7108 10.9701 17.6224C10.5782 17.5999 10.1865 17.5749 9.79496 17.5474C9.48538 16.8823 9.21414 16.2 8.98258 15.5039C8.76134 16.1649 8.44533 16.7884 8.19152 17.4364C7.83612 17.4313 7.47836 17.4168 7.12207 17.402C7.54025 16.5831 7.94422 15.7577 8.37544 14.9439C8.00908 14.1054 7.60719 13.2833 7.22928 12.4499C7.58744 12.4285 7.94561 12.4079 8.30377 12.388C8.54633 13.0244 8.81139 13.6529 9.0119 14.3056C9.22662 13.6138 9.54736 12.9628 9.8225 12.2935L9.8222 12.2926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.415 12.558H17.6955V13.6976H15.415V12.558ZM15.415 14.3486H17.6955V15.4882H15.415V14.3486ZM15.415 16.1392H17.6955V17.2788H15.415V16.1392ZM15.415 17.9298H17.6955V19.0695H15.415V17.9298Z",
    fill: "#207245"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_12568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3305,
    height: 14,
    fill: "white",
    transform: "translate(5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.5a9f218d26268ff55e94cb2373b18b8f.svg";
export { ForwardRef as ReactComponent };